import React, { useEffect, useRef, useState } from 'react';
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from 'react-icons/ai';
import { FiCheckSquare, FiSquare } from 'react-icons/fi';

function GroupedItemsContainer({
  groupName,
  groupedItems,
  value,
  onChoose,
  isOpen,
  onToggle,
}) {
  const [isItemInGroupChosen, setItemInGroupChosen] = useState(false);
  const itemsId = groupedItems[groupName].map((item) => item.id);
  const groupRef = useRef(null);

  function scrollToGroup() {
    if (isOpen) {
      groupRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  useEffect(() => {
    scrollToGroup();
  }, [isOpen]);

  useEffect(() => {
    const isAnyItemChosen = itemsId.some((itemId) => value.includes(itemId));
    setItemInGroupChosen(isAnyItemChosen);
  }, [value, itemsId]);

  if (groupName === 'undefined') {
    return (
      <div className={`group__items group__items_opened`}>
        {groupedItems[groupName].map((item) => {
          return (
            <p
              key={item.id}
              className={`dropdown-list__item ${
                value.includes(item.id) ? 'dropdown-list__item_selected' : ''
              }`}
              onClick={() => onChoose(item.id)}
            >
              {value.includes(item.id) ? <FiCheckSquare /> : <FiSquare />}
              {item.name}
            </p>
          );
        })}
      </div>
    );
  } else {
    return (
      <div className="group" ref={groupRef}>
        <h4
          className={`group__title${
            isItemInGroupChosen ? ' group__title_chosen' : ''
          }`}
          onClick={onToggle}
        >
          {groupName}
          {isOpen ? (
            <AiOutlineMinusCircle color="#fb089b" />
          ) : (
            <AiOutlinePlusCircle />
          )}
        </h4>
        <div className={`group__items${isOpen ? ' group__items_opened' : ''}`}>
          {groupedItems[groupName].map((item) => {
            return (
              <p
                key={item.id}
                className={`dropdown-list__item ${
                  value.includes(item.id) ? 'dropdown-list__item_selected' : ''
                }`}
                onClick={() => onChoose(item.id)}
              >
                {value.includes(item.id) ? <FiCheckSquare /> : <FiSquare />}
                {item.name}
              </p>
            );
          })}
        </div>
      </div>
    );
  }
}

export default GroupedItemsContainer;
